import { Component, ViewChild, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subject, noop } from 'rxjs';
import { Store } from '@ngrx/store';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil, filter } from 'rxjs/operators';
import { baseSharedSelectors, BaseCoreState } from '../../../_store';
import { NotificationResponse, MetaPagination } from '../../../../api';
import { BaseModalHeaderSizes } from '../../../shared/components/modal/base-modal.component';
import { BaseModalService } from '../../../shared/services/base-modal.service';

@Component({
  selector: 'base-notifications',
  templateUrl: './base-notifications.component.html',
})
export class BaseNotificationsComponent implements OnInit, OnDestroy {
  @ViewChild('notificationsPopup', { static: true }) notificationsPopup: ElementRef;

  isOpen = false;
  modalRef: NgbModalRef;
  allNotifications: Array<NotificationResponse> = [];
  unreadNotifications: Array<NotificationResponse> = [];
  totalUnreadNotifications = 0;
  pagination: MetaPagination | undefined;
  activeNotificationId?: number;

  private destroy$ = new Subject<void>();

  constructor(private store: Store<BaseCoreState>, private modalService: BaseModalService) {}

  ngOnInit() {
    this.store
      .select(baseSharedSelectors.getUserNotifications)
      .pipe(
        takeUntil(this.destroy$),
        filter((state) => !!state.ok)
      )
      .subscribe(({ data, pagination }) => {
        this.pagination = pagination;
        this.totalUnreadNotifications = data?.unRead || 0;
        this.allNotifications = data?.notifications ?? [];
        this.unreadNotifications = this.allNotifications.filter((item) => !item.isRead) ?? [];
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }

  notificationClick(id?: number) {
    this.openNotificationsModal(id);
  }

  private openNotificationsModal(id?: number) {
    this.activeNotificationId = id;

    this.modalRef = this.modalService.open(
      {
        headText: 'notification.pluralCapital',
        headerSize: BaseModalHeaderSizes.lg,
        bodyTemplate: this.notificationsPopup,
        scrollToTop: true,
        hideFooter: true,
        okButtonDisplayed: false,
        cancelButtonDisplayed: false,
      },
      {
        scrollable: true,
        backdrop: 'static',
        size: 'xl',
      }
    );

    this.modalRef.result.then(noop, noop);
  }
}
